import { useState, useRef, useCallback, useEffect } from 'react';

export const useThinkingTimer = () => {
    const [currentThinkingTime, setCurrentThinkingTime] = useState<number>(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
  
    const start = useCallback(() => {
      if (intervalRef.current) return; // Already running
      intervalRef.current = setInterval(() => {
        setCurrentThinkingTime(prev => parseFloat((prev + 0.1).toFixed(1)));
      }, 100);
    }, []);
  
    const stop = useCallback(() => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, []);
  
    const reset = useCallback(() => {
      stop();
      setCurrentThinkingTime(0);
    }, [stop]);
  
    // Cleanup on unmount
    useEffect(() => {
      return () => stop();
    }, [stop]);
  
    return {
      currentThinkingTime,
      start,
      stop,
      reset
    };
};